import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "_trackedOrders"

// `analytics` is Segment's global, minted by shared/_segment_head. It is absent in test and
// on any page whose layout omits that partial, so every effect below is gated on it.
export default class extends Controller {
  connect() {
    if (typeof analytics === "undefined") { return; }

    const orderId = this.config("orderid")
    if (this.alreadyTracked(orderId)) { return; }

    analytics.track("Order Completed", {
      $groups: { "Organization": this.config("organization") },
      $session_id: this.config("session-id"),
      $properties: {
        "Order ID": orderId,
        "Total": this.config("total")
      },
      $distinct_id: this.config("userid")
    })

    this.recordTrack(orderId)
    this.stripTrackingQueryParam()
  }

  // Read through jQuery rather than as Stimulus values, for its coercion: a numeric string
  // becomes a number only when it survives the round trip, so "12.5" is a number and "20.0" stays
  // a string. These land in a third-party payload, so the exact shape is preserved.
  config(key) {
    return $(this.element).data(key)
  }

  alreadyTracked(orderId) {
    if (!window.localStorage) { return false; }

    const stored = window.localStorage.getItem(STORAGE_KEY)
    return Boolean(stored) && JSON.parse(stored).includes(orderId)
  }

  recordTrack(orderId) {
    if (!window.localStorage) { return; }

    const stored = window.localStorage.getItem(STORAGE_KEY)
    const trackedOrders = stored ? JSON.parse(stored) : []

    trackedOrders.push(orderId)
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trackedOrders))
  }

  stripTrackingQueryParam() {
    if (!window.history || !window.history.replaceState) { return; }

    const queryParams = new URLSearchParams(window.location.search)
    queryParams.delete("completed")
    window.history.replaceState(null, null, `?${queryParams.toString()}`)
  }
}
